if (!window.mcTabbedCollectionsInit) {
  window.mcTabbedCollectionsInit = true;

  document.addEventListener('click', function(e) {
    const handle = e.target.closest('.mc-tabbed-collections__accordion--handle');
    if (!handle) return;

    const accordion = handle.closest('.mc-tabbed-collections__accordion');
    const content = accordion.querySelector('.mc-tabbed-collections__accordion--content');

    const isActive = accordion.classList.toggle('active');

    if (isActive) {
      content.style.overflow = 'hidden';
      content.style.maxHeight = 'none';
      const fullHeight = content.scrollHeight;
      content.style.maxHeight = '0px';
      content.offsetHeight;
      content.style.maxHeight = fullHeight + 'px';
      content.style.opacity = '1';
    } else {
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
    }
  });
}